import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import accept from 'attr-accept';
import wal10n from 'wa.admin-ui.l10n';
import Modal from '../../modal';
import ResourceDialog from './../../insert-resource';
import fileBrowserErrorStatus from './file-browser-error-status';
import LocalizationConsumer from '../../../l10n/localization-context';
import l10n from '../../../l10n/en';

import './insert-resource-dialog.css';

export const localStorageKeys = {
  DOCUMENT: 'InsertResourceDialogFileModeCurrentPath',
  IMAGE: 'InsertResourceDialogImageModeCurrentPath'
};

export const getResourcesPath = (env) =>
{
  const { location: { protocol, host, port } } = env;
  return `${protocol}//${host}${port ? `:${port}` : ''}/resources`;
};

export const getPicturePath = (env) =>
{
  return `${getResourcesPath(env)}/Pictures`;
};

export const getSavedPath = (env, isInsertDocumentMode) =>
{
  const storageKey = isInsertDocumentMode ? localStorageKeys.DOCUMENT : localStorageKeys.IMAGE;
  return env.localStorage.getItem(storageKey) || false;
};

export const getDefaultPath = (env, isInsertDocumentMode) =>
{
  return isInsertDocumentMode ? getResourcesPath(env) : getPicturePath(env);
};

export const resourcesFolderName = '/resources/';


export const friendlyViewPortSize = {
  width: 1920,
  height: 1280
};

export const acceptPictures = ['image/*'];

export const acceptDocuments = '';

export const insertValidationPicture = ({ isImage }) => isImage;

export const insertValidationDocuments = () => true;

class InsertResourceDialog extends PureComponent
{
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onInsert: PropTypes.func.isRequired,
    insertValidation: PropTypes.func.isRequired,
    // fileBrowserApiContainer: PropTypes.func.isRequired,
    env: PropTypes.shape({
      location: PropTypes.shape({
        protocol: PropTypes.string,
        host: PropTypes.string,
        port: PropTypes.string
      })
    }).isRequired,
    accept: PropTypes.arrayOf(PropTypes.string),
    isInsertDocumentMode: PropTypes.bool.isRequired
  };

  static defaultProps = {
    insertValidation: insertValidationPicture,
    env: window,
    accept: acceptPictures
  };

  constructor(props)
  {
    super(props);

    const { env, isInsertDocumentMode } = props;

    this.state = {
      lastUploadedFile: null,
      lastUploadedFileIndex: null,
      keepOriginalSize: false,
      isLoaded: false,
      retriedOnFileStructureError: false,
      location: [],
      items: null,
      currentPath: getSavedPath(env, isInsertDocumentMode) || getDefaultPath(env, isInsertDocumentMode)
    };
  }

  componentDidMount()
  {
    // this.fileBrowserApiContainer = new this.props.fileBrowserApiContainer();
    this.fileBrowserApiContainer = new WA.FileBrowser.FileBrowserApiContainer();
    this.fileBrowserApiContainer.ComponentReady.addHandler(this.fileBrowserApiInitCompleted);
  }

  componentDidUpdate()
  {
    const { lastUploadedFileIndex, lastUploadedFile } = this.state;
    if (lastUploadedFile === null && lastUploadedFileIndex !== null)
    {
      this.setState({ lastUploadedFileIndex: null });
    }
  }

  componentWillUnmount()
  {
    this.fileBrowserApiContainer.api.GetFolderItemsInfoSuccess.removeHandler(this.onGetFolderItemsInfoSuccess);
    this.fileBrowserApiContainer.api.AllFilesUploaded.removeHandler(this.onFilesUploaded);
    this.fileBrowserApiContainer.api.ProcessingError.removeHandler(this.onFilesUploaded);

    this.fileBrowserApiContainer.ComponentReady.removeHandler(this.fileBrowserApiInitCompleted);

    this.fileBrowserApiContainer = null;
  }

  fileBrowserApiInitCompleted = () =>
  {
    this.fileBrowserApiContainer.api.GetFolderItemsInfoSuccess.addHandler(this.onGetFolderItemsInfoSuccess);
    this.fileBrowserApiContainer.api.AllFilesUploaded.addHandler(this.onFilesUploaded);
    this.fileBrowserApiContainer.api.ProcessingError.addHandler(this.onProcessingErrors);

    this.fileBrowserApiContainer.api.getFolderItemsInfo(this.state.currentPath);
  };

  getFileThumbs = (item) =>
  {
    if (item.isFolder || (item.contentType).indexOf('image/') < 0)
    {
      return null;
    }


    return `${item['href']}?lm=${item['lastModified']}&width=128&height=128`;
  };

  mapItemsToResources = (item) =>
  {
    const {
      isFolder: isDirectory,
      displayName: name,
      src: fullPath,
      href,
      contentLength: size,
      creationDate: date,
      id,
      accessLevel
    } = item;

    const thumbSrc = this.getFileThumbs(item);
    const isImage = !!thumbSrc && !isDirectory;
    const isDocument = !isImage && !isDirectory;

    return {
      id,
      isDirectory,
      isDocument,
      isImage,
      name,
      thumbSrc,
      href,
      fullPath,
      accessLevel,
      size,
      date
    };
  };

  getLocationInfo = (folderInfo) =>
  {
    const { href, host } = folderInfo;
    const postResource = href.split(resourcesFolderName)[1].slice(0, -1);
    const locationPath = `${resourcesFolderName}${postResource}`;
    let accPath = '';
    return locationPath
      .split('/')
      .filter(folderName => folderName !== "")
      .map(folderName =>
      {
        accPath = `${accPath}${folderName}/`;
        return {
          name: decodeURI(folderName),
          path: `${host}${accPath}`
        }
      });
  };

  onGetFolderItemsInfoSuccess = (sender, args) =>
  {
    const { folderItemsInfo, folderInfo } = args;
    const items = folderItemsInfo.map(this.mapItemsToResources);
    let lastUploadedFileIndex = null;

    this.setState({ retriedOnFileStructureError: false });

    if (this.state.lastUploadedFile)
    {
      const lastFileIndex = items.findIndex(item =>
        item.name === this.state.lastUploadedFile.name);

      if (lastFileIndex !== -1)
      {
        lastUploadedFileIndex = lastFileIndex;
      }
    }

    this.setState({
      location: this.getLocationInfo(folderInfo),
      items: items,
      isLoaded: true,
      lastUploadedFile: null,
      lastUploadedFileIndex
    });
  };

  handleChangeLocation = (resource) =>
  {
    if (!resource) return;

    const { href } = resource;
    const { isInsertDocumentMode, env } = this.props;

    const storageKey = isInsertDocumentMode ? localStorageKeys.DOCUMENT : localStorageKeys.IMAGE;
    env.localStorage.setItem(storageKey, href);

    this.setState({
      isLoaded: false,
      currentPath: href
    });

    this.fileBrowserApiContainer.api.getFolderItemsInfo(href);
  };

  handleDropFiles = (files) =>
  {
    const { keepOriginalSize } = this.state;

    const acceptedFiles = [...files].filter(f => accept(f, this.props.accept));

    this.setState({
      isLoaded: false
    });

    this.setState({ lastUploadedFile: acceptedFiles[acceptedFiles.length - 1] });

    this.fileBrowserApiContainer.api.uploadFiles({
      uploadUrl: this.state.currentPath,
      fileList: acceptedFiles,
      friendlyViewPortSize: keepOriginalSize ? null : friendlyViewPortSize
    });
  };

  handleChangeKeepOriginalSize = (keepOriginalSize) =>
  {
    this.setState({ keepOriginalSize })
  };

  onFilesUploaded = () =>
  {
    this.fileBrowserApiContainer.api.getFolderItemsInfo(this.state.currentPath);
  };

  onProcessingErrors = (sender, args) =>
  {
    let errorMessage;

    const { currentPath, retriedOnFileStructureError } = this.state;
    const { env, isInsertDocumentMode, onCancel } = this.props;

    let path = currentPath;

    switch (args.errorStatus)
    {
      case fileBrowserErrorStatus.UnableToRenameFolderAlreadyExists:
      case fileBrowserErrorStatus.UnableToCreateFolderAlreadyExists:
        errorMessage = l10n['insert-image-dialog.error.directory-exists'];
        break;
      case fileBrowserErrorStatus.RenameFolderGeneralError:
        errorMessage = l10n['insert-image-dialog.error.rename-directory'];
        break;
      case fileBrowserErrorStatus.CreateFolderGeneralError:
        errorMessage = l10n['insert-image-dialog.error.create-directory'];
        break;
      case fileBrowserErrorStatus.DeleteFolderError:
        errorMessage = l10n['insert-image-dialog.error.delete-directory'];
        break;
      case fileBrowserErrorStatus.FileExists:
        errorMessage = l10n['insert-image-dialog.error.file-exists'];
        break;
      case fileBrowserErrorStatus.DeleteFileError:
        errorMessage = l10n['insert-image-dialog.error.delete-file'];
        break;
      case fileBrowserErrorStatus.InsufficientSpace:
        errorMessage = l10n['insert-image-dialog.error.insufficient-space'];
        break;
      case fileBrowserErrorStatus.BadFileName:
        errorMessage = l10n['insert-image-dialog.error.bad-file-name'];
        break;
      case fileBrowserErrorStatus.BadFileType:
        errorMessage = l10n['insert-image-dialog.error.bad-file-type'];
        break;
      case fileBrowserErrorStatus.BadFileSize:
        errorMessage = l10n['insert-image-dialog.error.bad-file-size'];
        break;
      case fileBrowserErrorStatus.GeneralFileStructureError:
        errorMessage = l10n['insert-image-dialog.error.general'];
        break;
      case fileBrowserErrorStatus.GeneralRequestException:
      case fileBrowserErrorStatus.GeneralFileUploadError:
      default:
        errorMessage = l10n['insert-image-dialog.error.general'];
        break;
    }

    if (retriedOnFileStructureError)
    {
      alert(errorMessage);
      onCancel();
      return;
    }

    if (args.errorStatus === fileBrowserErrorStatus.GeneralFileStructureError)
    {
      path = getResourcesPath(this.props.env); // if not find file set root (resources)

      const storageKey = isInsertDocumentMode ? localStorageKeys.DOCUMENT : localStorageKeys.IMAGE;
      env.localStorage.setItem(storageKey, path);

      this.setState({ retriedOnFileStructureError: true });
    }
    else
    {
      alert(errorMessage);
    }

    this.fileBrowserApiContainer.api.getFolderItemsInfo(path);
  };

  render()
  {
    const { onCancel, onInsert, accept, insertValidation, isInsertDocumentMode } = this.props;
    const { isLoaded, items, location, keepOriginalSize, lastUploadedFileIndex } = this.state;

    return (
      <Modal
        onCloseDialogClick={onCancel}
        withPadding={false}
        withoutHeightCalc
        size={{ width: '90%', height: '90%' }}
      >
        <Modal.Header>
          <LocalizationConsumer
            id={isInsertDocumentMode ? 'insert-resource-dialog.document.header' :
              'insert-resource-dialog.image.header'}
          />
        </Modal.Header>
        <Modal.Content className="resource-dialog-container">
          <ResourceDialog
            isInsertDocumentMode={isInsertDocumentMode}
            defaultSelectedIndex={lastUploadedFileIndex}
            insertValidation={insertValidation}
            accept={accept}
            keepOriginalSize={keepOriginalSize}
            isLoading={!isLoaded}
            location={location}
            currentResources={items}
            onChangeKeepOriginalSize={this.handleChangeKeepOriginalSize}
            onInsert={onInsert}
            onDropFiles={this.handleDropFiles}
            onCancel={onCancel}
            onChangeLocation={this.handleChangeLocation}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export default InsertResourceDialog;
